import React from 'react';

export default function Video({ fileUrl, onAttachmentClick }) {
    return <video onClick={onAttachmentClick} className='w-full max-h-80' src={fileUrl} controls />;
}
